module.exports = __webpack_public_path__ + "images/86096188116eef52a1651f7fe2bb001d-visitsaimaa_logo_vaaka.png";